import React from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const DetalleReasignarCitaMedicaModal = ({
  open,
  onClose,
  onOpenReasignarMedicoModal,
  openRescheduleDate,
  openRescheduleDate2,
}) => {
  if (!open) return null;

  return (
    <FlexContainer
      className="pos-fixed justify-center align-items-center"
      style={{
        inset: 0,
        minHeight: '100vh',
        flexDirection: 'column',
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
      }}
    >
      <div
        className="pos-rel"
        style={{
          borderRadius: '10px 10px 10px 10px',
          padding: '30px',
          width: 420,
          background: 'white',
          boxShadow: '0px 4px 20px rgba(0,0,0,0.20)',
          color: '#3A3A3A',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className="pos-abs top20 right20 pointer width-34px height-34px align-items-center justify-center text-18"
          style={{
            borderRadius: '50%',
            background: '#023B7A',
            color: 'white',
            fontWeight: '900',
            boxShadow: '0px 2px 5px rgba(2, 59, 122, 0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <div
          className="width-400px height-400px bgWhite borderrad20 padtb20 padlr10 pos-rel top30 margb20 right10"
          style={{
            zIndex: 5,
          }}
        >
          <FlexContainer
            className={'align-items-center gap-10 padtb0 margb8 padlr10'}
          >
            <FlexContainer
              className={
                'align-items-center width-24px height-24px justify-center pointer'
              }
              style={{ borderRadius: '50%', border: '2px solid #6f8ec0' }}
            >
              <span
                className={'text-20 lineHeight-1'}
                style={{ color: '#6f8ec0', fontWeight: 'bold' }}
              >
                ‹
              </span>
            </FlexContainer>

            <div className={'text-18'} style={{ fontWeight: 600 }}>
              <span style={{ color: '#023B7A' }}>
                <strong>Reagenda tu cita |</strong>
              </span>
              <span style={{ color: '#6f8ec0', fontWeight: 500 }}>
                {' '}
                Por horario o médico
              </span>
            </div>
          </FlexContainer>

          <Label
            className="text-16 font-bold block "
            style={{ color: '#023B7A' }}
          >
            <strong> Reagenda tu cita para</strong>{' '}
            <strong style={{ color: '#6f8ec0' }}>DANIEL DIAZ</strong>
          </Label>

          <Label className="text-14 block margb24" style={{ color: '#023B7A' }}>
            <strong> Elige cómo quieres empezar</strong>
          </Label>

          <FlexContainer></FlexContainer>

          <FlexContainer
            className="flex-row align-center pointer margb20 pad16"
            style={{
              border: '3px solid #000000',
              borderRadius: '4px',
            }}
            onClick={() => {
              onClose();
              openRescheduleDate();
            }}
          >
            <div>
              <Label
                className="text-14 font-bold block"
                style={{ color: '#023B7A' }}
              >
                <strong> Quiero ver otros horario </strong>
              </Label>
              <div
                style={{
                  width: '100%',
                  height: '1px',
                  backgroundColor: '#023B7A',
                  marginBottom: '15px',
                  marginTop: '5px',
                }}
              />
              <Label
                className="text-12 block margt4"
                style={{ color: '#023B7A' }}
              >
                Te mostraremos otras opciones con el mismo profesional.
              </Label>
            </div>
          </FlexContainer>

          <FlexContainer
            className="flex-row align-center pointer margb20 pad16"
            style={{
              border: '3px solid #000000',
              borderRadius: '4px',
            }}
            onClick={() => {
              onClose();
              onOpenReasignarMedicoModal();
            }}
          >
            <div>
              <Label
                className="text-14 font-bold block"
                style={{ color: '#023B7A' }}
              >
                <strong>Quiero ver otros médicos</strong>
              </Label>
              <div
                style={{
                  width: '100%',
                  height: '1px',
                  backgroundColor: '#023B7A',
                  marginBottom: '15px',
                  marginTop: '5px',
                }}
              />
              <Label
                className="text-12 block margt4"
                style={{ color: '#023B7A' }}
              >
                Te mostraremos el listado completo de médicos para que puedas
                elegir.
              </Label>
            </div>
          </FlexContainer>

          <FlexContainer className="flex-col align-center justify-center margt30">
            <Label
              className="text-12 block margb6"
              style={{ color: '#023B7A' }}
            >
              <strong> ¿Te equivocaste de especialidad?</strong>
            </Label>
          </FlexContainer>
          <FlexContainer
            className="flex-col align-center justify-center "
            onClick={() => {
              onClose();
              openRescheduleDate2();
            }}
          >
            <Label
              className="text-12 pointer font-bold text-center"
              style={{
                color: '#6f8ec0',
                cursor: 'pointer',
              }}
            >
              Anula tu cita
            </Label>
          </FlexContainer>
        </div>
      </div>
    </FlexContainer>
  );
};

export default DetalleReasignarCitaMedicaModal;
